import { LatLng } from 'leaflet';
import { DrawPolyLine } from '../components/DrawControl.models/Draw.polyline';
import { IUndoRedoCommand } from './undoRedoCommand';

export class AddPolylineVertexCommand implements IUndoRedoCommand {
  private readonly polyline: DrawPolyLine;
  private readonly latlng: LatLng;

  constructor(polyline: DrawPolyLine, latlng: LatLng) {
    this.polyline = polyline;
    this.latlng = latlng;
  }

  executeUndo(): void {
    if (this.polyline._markers.length === 1) {
      this.polyline.disable();
      this.polyline.enable();
      return;
    }

    this.polyline.deleteLastVertex();
    this.polyline.addLayer(this.polyline._markers[this.polyline._markers.length - 1]);

    this.polyline._updateGuide();
  }

  executeRedo(): void {
    this.polyline.addVertex(this.latlng);

    this.polyline._updateGuide();
  }
}
